import {
  MouseSensor,
  TouchSensor,
  KeyboardSensor,
  useSensor,
  useSensors,
  type DragEndEvent,
} from "@dnd-kit/core"
import { arrayMove } from "@dnd-kit/sortable"
import type { ColumnOrderState, OnChangeFn } from "@tanstack/react-table"

export const useDndSetup = (
  columnOrder: ColumnOrderState | undefined,
  onColumnOrderChange: OnChangeFn<ColumnOrderState> | undefined,
) => {
  // Setup DnD sensors for drag and drop
  const sensors = useSensors(
    useSensor(MouseSensor, {}),
    useSensor(TouchSensor, {}),
    useSensor(KeyboardSensor, {}),
  )

  // Handle drag end event
  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event

    if (active && over && active.id !== over.id && onColumnOrderChange) {
      const oldIndex = columnOrder?.indexOf(active.id as string) ?? -1
      const newIndex = columnOrder?.indexOf(over.id as string) ?? -1

      if (oldIndex !== -1 && newIndex !== -1 && columnOrder) {
        const newOrder = arrayMove(columnOrder, oldIndex, newIndex)
        onColumnOrderChange(newOrder)
      }
    }
  }

  return { sensors, handleDragEnd }
}
